import { BaseService } from './BaseService';
import { ConfigApi } from '../config/Constantes';

class ProdutoUnidadeService extends BaseService {
  constructor() {
    super(`${ConfigApi.ProdutoUnidadeURL}`);
    this.filter = new Filter();
  }

  getFilter() {
    return this.filter;
  }

  setFilter(filter) {
    this.filter = filter;
  }
}

class Filter {
  constructor() {
    this.sigla = '';
    this.limit = 11;
    this.page = 0;
  }
}
export default new ProdutoUnidadeService();
